import type * as React from 'react';

export function CustomTriangleDangerIcon({
    size = 24,
    color = 'currentColor',
    strokeWidth = 1.5,
    className,
    ...props
}: React.SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
    strokeWidth?: number;
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            strokeWidth={strokeWidth}
            viewBox="0 0 16 15"
            fill="none"
            className={className}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.82005 1.125C6.6863 -0.375 8.8523 -0.375 9.7178 1.125L15.234 10.686C16.0995 12.186 15.0165 14.061 13.2848 14.061H2.25305C0.521299 14.061 -0.560951 12.186 0.304549 10.686L5.8193 1.125H5.82005ZM7.7693 5.06025C7.91848 5.06025 8.06156 5.11951 8.16705 5.225C8.27254 5.33049 8.3318 5.47357 8.3318 5.62275V8.43525C8.3318 8.58443 8.27254 8.72751 8.16705 8.833C8.06156 8.93849 7.91848 8.99775 7.7693 8.99775C7.62011 8.99775 7.47704 8.93849 7.37155 8.833C7.26606 8.72751 7.2068 8.58443 7.2068 8.43525V5.62275C7.2068 5.47357 7.26606 5.33049 7.37155 5.225C7.47704 5.11951 7.62011 5.06025 7.7693 5.06025ZM7.7693 11.2477C7.91848 11.2477 8.06156 11.1885 8.16705 11.083C8.27254 10.9775 8.3318 10.8344 8.3318 10.6852C8.3318 10.5361 8.27254 10.393 8.16705 10.2875C8.06156 10.182 7.91848 10.1227 7.7693 10.1227C7.62011 10.1227 7.47704 10.182 7.37155 10.2875C7.26606 10.393 7.2068 10.5361 7.2068 10.6852C7.2068 10.8344 7.26606 10.9775 7.37155 11.083C7.47704 11.1885 7.62011 11.2477 7.7693 11.2477Z"
                fill={color}
            />
        </svg>
    );
}
